// @flow
import React from 'react';
import { Link } from 'react-router';
import { Trans } from 'react-i18next';

import TariffModal from 'app/components/Subs/TariffModal';
import TariffsList from 'app/components/Subs/TariffsList';

import enhanceToChange from './enhanceToChange';
import styles from './Nope.scss';


type Props = {
  service?: string,
  studentId: number,
  isOpen: boolean,
  handleToggle: (e: SyntheticEvent<HTMLElement>) => void,
  subId?: number,
  t: (s: string, t: Object) => string,
};

const ToChange = ({ service, studentId, isOpen, handleToggle, subId, t }: Props) => (
  <div>
    <div className={styles.text}>
      <Trans i18nKey="subs:not_subscribed">
        {'Не оформлена подписка или выбранным Вами тарифом не предусмотрено использование приложения в личном кабинете.'}
      </Trans>
      <br />
      {service
        ? <Trans i18nKey="subs:not_subscribed_todo">
          {'Вернитесь '}
          <Link to="/apps">назад к приложениям</Link>
          {' или '}
          <a href="tariffs" onClick={handleToggle}>смените тариф</a>
          {'.'}
        </Trans>
        : <Trans i18nKey="subs:not_subscribed_todo_no_sevice">
          {'Вернитесь '}
          <Link to="/apps">назад к приложениям</Link>
          {'.'}
        </Trans>}
    </div>
    {isOpen
      && service
      && <TariffModal
        title={t('tariff_list_title')}
        description={t('tariff_list_description', { appName: t(service) })}
        close={handleToggle}
      >
        <TariffsList
          service={service}
          studentId={studentId}
          currentSubId={subId}
          close={handleToggle}
        />
      </TariffModal>}
  </div>
);

export default enhanceToChange(ToChange);
